<template>
  <div class="hexagram-container">
    <div class="hexagram-wrapper">
      <!-- 상괘 자리 -->
      <div class="trigram-slot">
        <transition name="fade" mode="out-in">
          <img v-if="stage >= 2" :src="current.sang" class="trigram-svg" />
        </transition>
      </div>

      <!-- 하괘 자리 -->
      <div class="trigram-slot">
        <transition name="fade" mode="out-in">
          <img v-if="stage >= 1" :src="current.ha" class="trigram-svg" />
        </transition>
      </div>

      <!-- 괘명 표시 -->
      <div class="hexagram-name-slot">
        <transition name="fade" mode="out-in">
          <div v-if="stage === 3" class="hexagram-name">
            {{ current.fullName }}
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { ref, onMounted } from 'vue'
  import { trigrams as hexagrams } from '@/data/hexagramData.js'

  const current = ref(hexagrams[0])
  const stage = ref(0) // 0: 없음, 1: 하괘, 2: 상괘, 3: 괘명

  const animate = () => {
    const next = getRandomHexagram()
    current.value = next
    stage.value = 0

    setTimeout(() => {
      stage.value = 1 // 하괘 표시
      setTimeout(() => {
        stage.value = 2 // 상괘 표시
        setTimeout(() => {
          stage.value = 3 // 괘명 표시
          setTimeout(() => {
            stage.value = 0
            setTimeout(animate, 1000)
          }, 2000)
        }, 1000)
      }, 1000)
    }, 500)
  }

  const getRandomHexagram = () => {
    const randomIndex = Math.floor(Math.random() * hexagrams.length)
    return hexagrams[randomIndex]
  }

  onMounted(() => {
    animate()
  })
</script>

<style scoped>
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.6s ease;
  }
  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
  }

  .hexagram-container {
    display: flex;
    flex-direction: column;
    background-color: black;
  }

  .hexagram-wrapper {
    display: flex;
    margin: auto; /* Centers the wrapper horizontally and vertically */
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 18px;
  }

  .trigram-slot {
    height: 70.2px;
    width: 114.66px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
  }

  .trigram-svg {
    width: 114.66px;
    height: 70.2px;
  }

  .hexagram-name-slot {
    height: 36px; /* 24px * 1.5 */
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
  }

  .hexagram-name {
    text-align: center;
    font-size: var(--font-size-12);
    font-weight: normal;
    color: white;
  }
</style>
